import { connect } from 'react-redux';
import AdvisorUrgencySignal from './advisor_urgency_signal';

const mapStateToProps = ({ user }) => ({
  fbm: user?.user?.analytics?.['fbm date']
});

export default connect(mapStateToProps)(AdvisorUrgencySignal);
